/* eslint-disable */
// @ts-nocheck
import React from 'react';
import deepFreeze from './deepFreeze';
import Tier3Description from '../components/ModalPremiumProduct/Descriptions/Tier3Description';
import Tier0Description from '../components/ModalPremiumProduct/Descriptions/Tier0Description';
import { Tier } from '../types/pricing/Tier';

export const REACT_APP_ID = 'app';

export const DEEPVIEW_PLATFORMS = [
  {
    key: 'ios',
    title: 'iOS',
    dimensions: { width: 247, height: 430 },
    zoom: '.8',
  },
  {
    key: 'android',
    title: 'Android',
    dimensions: { width: 270, height: 442 },
    zoom: '.8',
  },
  {
    key: 'desktop',
    title: 'Desktop',
    dimensions: { width: 350, height: 250 },
    zoom: '.4',
  },
];
deepFreeze(DEEPVIEW_PLATFORMS);

export const EMAIL_PRODUCT_SKU = 'SKU-00000001';
export const EMAIL_PRODUCT_SKU_MAU = EMAIL_PRODUCT_SKU;
export const MARKETPLACE_PRODUCT_SKU = 'SKU-00000003';
export const JOURNEYS_PRODUCT_SKU = 'SKU-00000008';
export const JOURNEYS_PRODUCT_SKU_MAU = JOURNEYS_PRODUCT_SKU;
export const ADS_PRODUCT_SKU = 'SKU-00000027';
export const ADS_PRODUCT_SKU_MAU = ADS_PRODUCT_SKU;
export const MULTI_PRODUCT_DISCOUNT_SKU = 'SKU-00000029';
export const DATA_FEEDS_PRODUCT_SKU_MAU = 'SKU-00000030';
export const OTT_SKU = 'SKU-00000051';

export const SUPPORT_EMAIL_HREF = 'mailto:support@branch.io';
export const SUPPORT_TICKET_HREF = 'https://support.branch.io/support/tickets/new';
export const BILLING_EMAIL_HREF = 'mailto:billing@branch.io';
export const LEARN_MORE_PRICING = 'https://branch.io/pricing/';
export const DEMO_MAU_THRESHOLD = 50000;
export const DEMO_TEXT = 'Request a Demo';
export const DEMO_HREF = 'https://www2.branch.io/request-a-demo/';

export const ZUORA_HOSTED_PAYMENT_CONFIG = {
  style: 'inline',
  submitEnabled: 'true',
  param_supportedTypes: 'AmericanExpress,Visa,MasterCard,Discover',
};

/* BILLING MODAL CONSTANTS */
export const TRIAL_TEXT = '14 day free trial';

export const MAU_BILLING_TIER_IDS = {
  LAUNCH: 'Tier0',
  STARTUP: 'Tier1',
  ENTERPRISE: 'Tier3',
};
export const MAU_BILLING_TIER_NAMES = {
  LAUNCH: 'Launch',
  STARTUP: 'Startup',
  ENTERPRISE: 'Enterprise',
};

export const TIER_0: Tier = {
  deprecated: false,
  title: MAU_BILLING_TIER_NAMES.LAUNCH,
  price: '0',
  mau_text: 'UP TO',
  mau_value: '10k MAUs',
  mau_num: 150000,
  tier_id: 'Tier0',
  description: {
    componentOnly: false,
    component: <Tier0Description />,
  },
};

// TO BE DEPRECATED
export const TIER_1: Tier = {
  deprecated: true,
  title: MAU_BILLING_TIER_NAMES.STARTUP,
  price: '59',
  mau_text: 'UP TO',
  mau_value: '50k MAUs',
  mau_num: 50000,
  tier_id: 'Tier1',
};

// DEPRECATED
export const TIER_2: Tier = {
  deprecated: true,
  title: 'Growth',
  price: '199',
  mau_text: 'UP TO',
  mau_value: '200k MAUs',
  mau_num: 200000,
  link: '/',
  tier_id: 'Tier2',
};

export const TIER_3: Tier = {
  deprecated: false,
  title: MAU_BILLING_TIER_NAMES.ENTERPRISE,
  price: 'Custom Pricing',
  mau_text: 'MORE THAN',
  mau_value: TIER_0.mau_value,
  mau_num: Infinity,
  enterprise: true,
  tier_id: 'Tier3',
  description: {
    componentOnly: true,
    component: <Tier3Description />,
  },
};

export const SELF_SERVE_PLATFORM: Tier = {
  deprecated: false,
  title: 'Self-Serve Platform',
  price: '0',
  mau_text: 'UP TO',
  mau_value: '10k MAUs',
  mau_num: 150000,
  tier_id: 'Self-Serve Platform',
  description: {
    componentOnly: false,
    component: <Tier0Description />,
  },
};

export const ENTERPRISE_ONLY_MAU = 1000000;

export const MAU_ALL_TIERS = [TIER_0, TIER_1, TIER_2, TIER_3];

export const MAU_BILLING_TIERS = MAU_ALL_TIERS.filter((tier) => !tier.deprecated);

// we still need to display on subscription change
// screen if client has deprecated tiers
export const MAU_DEPRECATED_TIERS = MAU_ALL_TIERS.filter((tier) => tier.deprecated);

export const ADS_BILLING_CONFIG = {
  name: 'Deep Linked Ads',
  title: 'Sign up for Universal Ads',
  sku: ADS_PRODUCT_SKU_MAU,
};

export const DATA_FEEDS_BILLING_CONFIG = {
  name: 'Data Feeds',
  title: 'Sign up for Data Feeds',
  sku: DATA_FEEDS_PRODUCT_SKU_MAU,
};

export const EMAIL_BILLING_CONFIG = {
  name: 'Universal Email',
  title: 'Sign up for Universal Email',
  sku: EMAIL_PRODUCT_SKU_MAU,
};

export const OTT_BILLING_CONFIG = {
  name: 'OTT',
  title: 'Sign up for OTT',
  sku: OTT_SKU,
};

export const JOURNEYS_BILLING_CONFIG = {
  name: 'Journeys',
  title: 'Sign up for Journeys',
  sku: JOURNEYS_PRODUCT_SKU_MAU,
};

export const LOADING_STATUS = {
  INIT: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const SSO_REQUIRED_FIELDS = ['email_domain', 'subdomain', 'issuer_url', 'sso_url', 'certificate', 'status'];

export const AGENCY_LINK_KEY = '~agency_id';

export const SIDE_BAR_WIDTH = 768;

export const LOCAL_CURRENCY_BRANCH_FIELD_DROPDOWN_OPTIONS = ['event_data_revenue_in_local_currency'];
